import {Injectable} from "@angular/core";
import {DisputeEvidenceSubmitRequestData, EvidenceFile} from "./dispute-evidence-submit-request.data";
import {DisputeService} from "./dispute.service";
import {DisputeViewData} from "./dispute-view.data";

@Injectable()
export class DisputeModel {

    disputeId: string;

    dispute: DisputeViewData;
    disputeEvidenceRequest: DisputeEvidenceSubmitRequestData = new DisputeEvidenceSubmitRequestData();

    constructor(private disputeService: DisputeService) {
    }

    refresh(): void {
    }

    addEvidenceFile(fileId: string, evidenceType: string, fileName: string): void {
        const evidenceFile: EvidenceFile = new EvidenceFile();
        evidenceFile.fileId = fileId;
        evidenceFile.evidenceType = evidenceType;
        evidenceFile.fileName = fileName;

        this.disputeEvidenceRequest.evidenceFiles.push(evidenceFile);
    }

    async submitEvidence(): Promise<void> {
        this.disputeEvidenceRequest.disputeId = this.disputeId;
        await this.disputeService.submitEvidence(this.disputeEvidenceRequest);
    }

    async loadDispute(): Promise<void> {
        this.dispute = await this.disputeService.getDispute(this.disputeId);
    }
}
